import classes from './profileSettingsBanner.scss';

const sceBanner = (props) => {
  return (
    <div className={classes.sceFormBanner}>
      <div className={classes.sceBannerMessageContainer}>
        <div className={classes.sceBannerMessage}>
          <div className={classes.sceSingleStatement}>
            {props.message}
          </div>
        </div>
      </div>
    </div>
  );
};

export default sceBanner;